export default function canUseCombiner(url = '') {
    return (url.indexOf('espncdn.com') !== -1);
}



// WEBPACK FOOTER //
// ./app/lib/url-adapter/canUseCombiner.js